import Util from '@/helper/Utility.js';

export function SaveCartModel() {
    this.cartList = null;
    this.deliveryMethod = '';
    this.addressKey = null;
    this.locationId = null;
    this.center = null;
    this.orderPlan = null;
    this.deliverTime = null;

    /**
     * Set parameter for deliveryMethodModel.
     */
    this.setDelivery = (dict) => {
        if (dict.deliveryMethod == 'Delivery') {
            this.deliveryMethod = dict.deliveryMethod;
            this.addressKey = dict.address.rowKey;
            this.deliverTime = dict.deliverTime;
        } else {
            this.deliveryMethod = dict.deliveryMethod;
            this.locationId = dict.location.id;
            this.orderPlan = dict.orderPlan;
            this.center = dict.location.latitude + "," + dict.location.longtitude;
            this.deliverTime = dict.deliverTime;
        }
    }

    /**
     * Get parameter for api.
     */
    this.getParams = () => {
        var arrCartItemAll = [];
        for (var cartItem of this.cartList) {
            arrCartItemAll.push(cartItem.getParams());
        }

        var params = {};
        if (this.deliveryMethod == "Delivery") {
            params = {
                deliveryMethod: this.deliveryMethod,
                addressKey: this.addressKey,
                json: Util.toJsonStr(arrCartItemAll),
                delivertime: this.deliverTime
            }
        } else {
            params = {
                deliveryMethod: this.deliveryMethod,
                locationId: this.locationId,
                orderPlan: this.orderPlan,
                center: this.center,
                json: Util.toJsonStr(arrCartItemAll),
                delivertime: this.deliverTime
            }
        }

        return Util.cleanObjectEmptyStr(params);
    };
}
